import { ItineraryHeightModeType } from '@/app/ui/trip/client-trip-page';
import { DestinationCGType, PoiCGType, SurveyCGType } from '@/types/graphql/root';
import { atom } from 'jotai';

export const tripPoiModalAtom = atom<{
  useItineraryHeightMode: [ItineraryHeightModeType, React.Dispatch<React.SetStateAction<ItineraryHeightModeType>>];
  itineraryHeightValues: {
    full: string;
    default: string;
    minimalize: string;
  };
} | null>(null);

export const topDestSlotAtom = atom<DestinationCGType | null>(null);

export const isEditRoleAtom = atom<boolean>(false);
export const globalIamEditAtom = atom<boolean>(false);
export const globalEditUserAtom = atom<string | null>(null);
export const globalTripIdAtom = atom<string | null>(null);
export const globalTripDestinationsAtom = atom<DestinationCGType[] | null>(null);
export const globalTripAtom = atom<SurveyCGType | null>(null);
export const globalPoiAtom = atom<PoiCGType | null>(null);
